<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  @if (primaryPeriodsExpiringSoon(); as primaryPeriodsExpiringSoon) {
    <rx-alert [title]="t('expiringTitle')" [type]="'warning'">
      @for (periodExpiringSoon of primaryPeriodsExpiringSoon; track periodExpiringSoon.fullName) {
        {{
          t('expiringText', {
            fullName: periodExpiringSoon.fullName,
            endDate: periodExpiringSoon.endDateTimeUtc | date: FULL_DAY_NAME_MONTH_NAME_WITH_TIME,
            startDate: periodExpiringSoon.startDateTimeUtc | date: FULL_DAY_NAME_MONTH_NAME_WITH_TIME,
          })
        }}
      }
    </rx-alert>
  }
  @if (primaryPeriodsExpiringAfter24h(); as primaryPeriodsExpiringAfter24h) {
    <rx-alert [title]="t('chosenTitle')" [type]="'info'">
      @for (periodsExpiringAfter24h of primaryPeriodsExpiringAfter24h; track periodsExpiringAfter24h.fullName) {
        {{
          t('chosenText', {
            fullName: periodsExpiringAfter24h.fullName,
            endDate: periodsExpiringAfter24h.endDateTimeUtc | date: FULL_DAY_NAME_MONTH_NAME_WITH_TIME,
            startDate: periodsExpiringAfter24h.startDateTimeUtc | date: FULL_DAY_NAME_MONTH_NAME_WITH_TIME,
          })
        }}
      }
    </rx-alert>
  }
</ng-container>
